import { GenericType } from '../../../../model/base/edl-generic-type.model';
import { EdlComment } from '../../../../model/comment.model';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { ObservationSummaryDTO } from 'src/app/model/observation/observation-summary-dto.model';

@Component({
  selector: 'app-observation-comment-controller-modal',
  templateUrl: './observation-comment-controller-modal.component.html',
  styleUrls: ['./observation-comment-controller-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class ObservationCommentControllerModal {
  @Input() observationSummary?: ObservationSummaryDTO;
  @Input() comment?: EdlComment;
  @Input() active?: number;
  @Input() observationType?: GenericType;
  @Input() observationId?: string;
  @Input() defaultLookupValue?: string;
  @Input() hideLookup?: boolean = true;


    constructor(
        public activeModal: NgbActiveModal,
    ) { }

    onClose() {
        this.activeModal.close();
    }
}
